<script setup>
import { Actions, EventManager } from "@events";
import VideoCallButton from "../Common/VideoCallButton.vue";

import { useVideoCallState } from "@/stores/videoCallState";
import { computed } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);
const state = useVideoCallState(props.rtcId);

function toggleMute() {
  actionEmitter.emit(
    state.videoMuted ? Actions.UnmuteVideo : Actions.MuteVideo
  );
}

const iconClass = computed(() => {
  if (state.videoMuted) {
    return "mdi-video-off";
  }
  return "mdi-video";
});
</script>
<template>
  <VideoCallButton
    :active="state.videoMuted"
    :icon="iconClass"
    @click="toggleMute"
    :disabled="state.disableVideoControls"
  ></VideoCallButton>
</template>
